const Skin = ({ id }) => (
  <defs><linearGradient id={id} x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#f6cba2" /><stop offset="1" stopColor="#eab587" /></linearGradient></defs>
);

const DorsalHand = ({ x, y, rotate = 0, scale = 1 }) => (
  <g transform={`translate(${x} ${y}) rotate(${rotate}) scale(${scale})`}>
    <path d="M0 -12 C 10 -16, 22 -15, 30 -10 C 34 -7, 35 -3, 34 1 L 34 6 C 33 12, 26 16, 16 16 C 8 16, 2 14, 0 10 Z" fill="#f0bd90" />
    <path d="M6 -12 C 10 -20, 17 -25, 24 -26" stroke="#f0bd90" strokeWidth="6.5" strokeLinecap="round" />
    <path d="M32 -9 C 42 -11, 50 -10, 54 -6" stroke="#f0bd90" strokeWidth="6.5" strokeLinecap="round" />
    <path d="M34 -2 C 45 -3, 53 -1, 57 3" stroke="#f0bd90" strokeWidth="6.5" strokeLinecap="round" />
    <path d="M33 5 C 43 6, 50 8, 54 12" stroke="#f0bd90" strokeWidth="6" strokeLinecap="round" />
    <path d="M30 12 C 38 14, 44 16, 47 19" stroke="#f0bd90" strokeWidth="5" strokeLinecap="round" />
    <path d="M6 12 C 14 14, 24 14, 30 10" stroke="#d99f72" strokeWidth="2" strokeLinecap="round" opacity="0.6" />
  </g>
);

export const JellyfishHero = () => (
  <svg viewBox="0 0 220 240" fill="none" role="img" aria-label="Ilustrasi ubur-ubur secara umum">
    <defs>
      <linearGradient id="jellyDome" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#e8536a" /><stop offset="1" stopColor="#c22338" /></linearGradient>
      <linearGradient id="jellyInner" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#ffd9d4" /><stop offset="1" stopColor="#f1938d" /></linearGradient>
    </defs>
    <circle cx="110" cy="104" r="94" fill="#fff0ed" />
    <circle cx="34" cy="56" r="5" fill="#f6c5bf" />
    <circle cx="186" cy="44" r="7" fill="#f6c5bf" />
    <circle cx="176" cy="150" r="4.5" fill="#f6c5bf" />
    <circle cx="50" cy="162" r="4" fill="#f6c5bf" />
    <circle className="bubble" cx="152" cy="72" r="4" fill="#f9d5d1" />
    <circle className="bubble b2" cx="70" cy="50" r="3" fill="#f9d5d1" />
    <g className="jelly-float">
      <path d="M82 108 C 76 126, 88 138, 82 156 C 78 168, 86 178, 82 190" stroke="#e58b85" strokeWidth="7" strokeLinecap="round" />
      <path d="M138 108 C 144 126, 132 138, 138 156 C 142 168, 134 178, 138 190" stroke="#e58b85" strokeWidth="7" strokeLinecap="round" />
      <path d="M100 110 C 95 128, 105 140, 99 158 C 95 170, 103 180, 99 192" stroke="#d92d3e" strokeWidth="7" strokeLinecap="round" />
      <path d="M120 110 C 125 128, 115 140, 121 158 C 125 170, 117 180, 121 192" stroke="#d92d3e" strokeWidth="7" strokeLinecap="round" />
      <path d="M110 110 C 104 122, 116 132, 110 146 C 106 156, 113 164, 110 174" stroke="#f1938d" strokeWidth="10" strokeLinecap="round" />
      <path d="M56 100 C 56 62, 80 38, 110 38 C 140 38, 164 62, 164 100 C 164 106, 160 110, 154 110 L 66 110 C 60 110, 56 106, 56 100 Z" fill="url(#jellyDome)" />
      <path d="M70 100 C 70 72, 88 54, 110 54 C 132 54, 150 72, 150 100 C 150 103, 148 105, 144 105 L 76 105 C 72 105, 70 103, 70 100 Z" fill="url(#jellyInner)" opacity="0.9" />
      <path d="M56 100 q9 10 18 0 q9 10 18 0 q9 10 18 0 q9 10 18 0 q9 10 18 0 q9 10 18 0" stroke="#a81c30" strokeWidth="4" fill="none" strokeLinecap="round" />
      <path d="M78 66 C 84 56, 94 50, 104 48" stroke="#ffd3ce" strokeWidth="7" strokeLinecap="round" />
    </g>
    <path d="M16 206 C 32 195, 48 195, 64 206 C 80 217, 96 217, 112 206 C 128 195, 144 195, 160 206 C 176 217, 190 217, 204 208" stroke="#f3b7b1" strokeWidth="6" strokeLinecap="round" />
    <path d="M38 224 C 50 216, 62 216, 74 224 C 86 232, 98 232, 110 224 C 122 216, 134 216, 146 224 C 158 232, 168 232, 180 226" stroke="#f9d5d1" strokeWidth="6" strokeLinecap="round" />
  </svg>
);

export const StingFigure = () => (
  <svg viewBox="0 0 220 130" fill="none" role="img" aria-label="Ilustrasi lokasi sengatan pada lengan">
    <Skin id="skinSting" />
    <circle cx="110" cy="65" r="56" fill="#fff0ed" />
    <path d="M18 90 C 52 80, 86 71, 118 65 C 121 65, 123 67, 123 70 L 123 88 C 123 91, 121 93, 118 93 C 84 99, 50 106, 24 110 C 16 111, 12 106, 13 99 C 14 95, 15 92, 18 90 Z" fill="url(#skinSting)" />
    <path d="M26 106 C 56 100, 90 94, 116 90" stroke="#d99f72" strokeWidth="3" strokeLinecap="round" opacity="0.5" />
    <ellipse cx="82" cy="85" rx="26" ry="12" fill="#d92d3e" opacity="0.12" transform="rotate(-10 82 85)" />
    <path d="M62 77 C 66 82, 66 89, 62 96" stroke="#c22338" strokeWidth="4" strokeLinecap="round" />
    <path d="M76 74 C 81 80, 81 89, 76 97" stroke="#d92d3e" strokeWidth="4" strokeLinecap="round" />
    <path d="M91 72 C 96 78, 96 86, 91 93" stroke="#c22338" strokeWidth="4" strokeLinecap="round" />
    <path d="M105 69 C 109 75, 109 81, 105 87" stroke="#e8536a" strokeWidth="3.5" strokeLinecap="round" />
    <circle cx="69" cy="84" r="1.6" fill="#c22338" /><circle cx="84" cy="82" r="1.6" fill="#c22338" /><circle cx="98" cy="79" r="1.4" fill="#e8536a" />
    <path d="M62 52 l-8 -10 M82 46 l-3 -12 M102 48 l4 -11" stroke="#e58b85" strokeWidth="4" strokeLinecap="round" />
    <DorsalHand x={120} y={77} rotate={-8} />
  </svg>
);

export const ShoreFigure = () => (
  <svg viewBox="0 0 220 130" fill="none" role="img" aria-label="Ilustrasi penolong memapah korban keluar dari air">
    <circle cx="110" cy="65" r="56" fill="#eaf6f1" />
    <path d="M124 130 C 136 102, 166 88, 208 82 L 208 130 Z" fill="#eed7a8" />
    <path d="M134 120 C 148 104, 168 94, 200 88" stroke="#e0c288" strokeWidth="4" strokeLinecap="round" />
    <path d="M12 102 C 24 95, 36 95, 48 102 C 60 109, 70 109, 82 104" stroke="#8fd0c4" strokeWidth="5" strokeLinecap="round" />
    <path d="M20 114 C 30 108, 40 108, 50 114 C 60 120, 68 120, 78 116" stroke="#cdece5" strokeWidth="5" strokeLinecap="round" />
    <circle cx="86" cy="34" r="8.5" fill="#f6cba2" />
    <path d="M86 42 v5" stroke="#f6cba2" strokeWidth="5" strokeLinecap="round" />
    <path d="M86 47 L84 76" stroke="#d92d3e" strokeWidth="14" strokeLinecap="round" />
    <path d="M91 50 C 100 50, 108 50, 116 52" stroke="#d92d3e" strokeWidth="6.5" strokeLinecap="round" />
    <path d="M81 50 C 74 56, 68 62, 63 70" stroke="#d92d3e" strokeWidth="6.5" strokeLinecap="round" />
    <circle cx="63" cy="71" r="4.2" fill="#f6cba2" />
    <path d="M80 74 h13 l-1 9 h-11 Z" fill="#20212b" />
    <path d="M83 82 C 80 90, 78 97, 76 104" stroke="#eab587" strokeWidth="7.5" strokeLinecap="round" />
    <ellipse cx="74" cy="108" rx="6.5" ry="3.6" fill="#eab587" />
    <path d="M90 82 C 96 88, 102 94, 108 100" stroke="#eab587" strokeWidth="7.5" strokeLinecap="round" />
    <ellipse cx="112" cy="103" rx="6.5" ry="3.6" fill="#eab587" />
    <path d="M76 100 l-5 -7 M86 97 l0 -9 M94 100 l5 -7" stroke="#a7dcd0" strokeWidth="3.5" strokeLinecap="round" />
    <circle cx="140" cy="30" r="8.5" fill="#eab587" />
    <path d="M140 38 v5" stroke="#eab587" strokeWidth="5" strokeLinecap="round" />
    <path d="M140 44 L141 76" stroke="#16846b" strokeWidth="14" strokeLinecap="round" />
    <path d="M134 48 C 128 50, 122 51, 118 52" stroke="#16846b" strokeWidth="6.5" strokeLinecap="round" />
    <circle cx="118" cy="52" r="4.4" fill="#f0bd90" />
    <path d="M147 48 C 153 54, 157 60, 160 66" stroke="#16846b" strokeWidth="6.5" strokeLinecap="round" />
    <circle cx="160" cy="67" r="4.2" fill="#eab587" />
    <path d="M135 76 h13 l-1 8 h-11 Z" fill="#20212b" />
    <path d="M138 84 C 137 92, 136 100, 135 108" stroke="#20212b" strokeWidth="8" strokeLinecap="round" />
    <path d="M145 84 C 147 92, 149 98, 151 104" stroke="#20212b" strokeWidth="8" strokeLinecap="round" />
    <ellipse cx="134" cy="111" rx="6.5" ry="3.4" fill="#20212b" />
    <ellipse cx="153" cy="107" rx="6.5" ry="3.4" fill="#20212b" />
  </svg>
);

export const RinseFigure = () => (
  <svg viewBox="0 0 220 130" fill="none" role="img" aria-label="Ilustrasi tangan memegang botol dan membilas sengatan dengan air laut">
    <Skin id="skinRinse" />
    <circle cx="110" cy="65" r="56" fill="#e8f6f1" />
    <path d="M22 98 C 56 89, 92 82, 124 76 C 127 75, 129 76, 129 79 L 129 90 C 129 93, 127 95, 124 95 C 92 100, 58 106, 28 110 C 20 111, 16 107, 17 102 C 18 100, 19 98, 22 98 Z" fill="url(#skinRinse)" />
    <path d="M70 88 C 73 92, 73 96, 70 100 M84 86 C 87 90, 87 95, 84 99" stroke="#d92d3e" strokeWidth="3" strokeLinecap="round" opacity="0.65" />
    <DorsalHand x={126} y={84} rotate={-6} scale={0.9} />
    <path d="M104 34 C 116 28, 128 24, 142 22" stroke="#eab587" strokeWidth="11" strokeLinecap="round" />
    <circle cx="97" cy="46" r="10" fill="#eab587" />
    <g transform="rotate(-125 96 44)">
      <rect x="82" y="22" width="28" height="38" rx="9" fill="#fff" stroke="#16846b" strokeWidth="4" />
      <rect x="90" y="12" width="12" height="12" rx="4" fill="#16846b" />
    </g>
    <path d="M84 36 C 92 42, 96 48, 96 56" stroke="#f0bd90" strokeWidth="5.5" strokeLinecap="round" />
    <path d="M91 31 C 99 37, 103 43, 103 51" stroke="#f0bd90" strokeWidth="5.5" strokeLinecap="round" />
    <path d="M98 26 C 106 32, 110 38, 110 46" stroke="#f0bd90" strokeWidth="5" strokeLinecap="round" />
    <path d="M82 52 C 78 58, 78 64, 84 68" stroke="#f6cba2" strokeWidth="6" strokeLinecap="round" />
    <path d="M74 60 C 73 68, 75 77, 78 85" stroke="#5fb8ae" strokeWidth="5" strokeLinecap="round" />
    <circle cx="72" cy="72" r="3" fill="#5fb8ae" />
    <circle cx="79" cy="81" r="3" fill="#5fb8ae" />
    <path d="M70 88 l-6 -5 M78 86 l1 -8 M84 90 l6 -5" stroke="#8fd0c4" strokeWidth="3.5" strokeLinecap="round" />
  </svg>
);

export const WarmSoak = () => (
  <svg viewBox="0 0 220 130" fill="none" role="img" aria-label="Ilustrasi baskom air hangat 40 sampai 42 derajat">
    <circle cx="110" cy="65" r="56" fill="#fdf0e4" />
    <path className="steam" d="M86 42 C 82 36, 90 32, 86 26" stroke="#e8b4ac" strokeWidth="4" strokeLinecap="round" />
    <path className="steam s2" d="M110 38 C 106 32, 114 28, 110 22" stroke="#e8b4ac" strokeWidth="4" strokeLinecap="round" />
    <path className="steam s3" d="M134 42 C 130 36, 138 32, 134 26" stroke="#e8b4ac" strokeWidth="4" strokeLinecap="round" />
    <path d="M58 76 L162 76 L152 108 C 150 113, 145 116, 139 116 L81 116 C 75 116, 70 113, 68 108 Z" fill="#fff" stroke="#e3c9b8" strokeWidth="4" />
    <path d="M64 80 L156 80 L153 92 C 130 99, 96 99, 67 92 Z" fill="#bfe3dd" />
    <path d="M78 82 q6 5 12 0 q6 -5 12 0 M104 83 q6 5 12 0" stroke="#8fd0c4" strokeWidth="3.5" strokeLinecap="round" />
    <rect x="148" y="18" width="58" height="22" rx="11" fill="#d92d3e" />
    <text x="177" y="33" textAnchor="middle" fontFamily="Manrope, sans-serif" fontWeight="700" fontSize="11" fill="#fff">40–42°C</text>
  </svg>
);

export const MonitoringFigure = () => (
  <svg viewBox="0 0 220 130" fill="none" role="img" aria-label="Ilustrasi penolong duduk mendampingi dan memantau korban">
    <circle cx="110" cy="65" r="56" fill="#e8f6f1" />
    <path d="M52 26 h18 l6 -12 l7 22 l6 -14 l6 8 h20" stroke="#d92d3e" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="50" y="90" width="56" height="7" rx="3.5" fill="#c9a15f" />
    <path d="M58 97 v14 M98 97 v14" stroke="#c9a15f" strokeWidth="5" strokeLinecap="round" />
    <circle cx="76" cy="46" r="9" fill="#f6cba2" />
    <path d="M76 55 v4" stroke="#f6cba2" strokeWidth="5" strokeLinecap="round" />
    <path d="M78 60 C 76 70, 78 80, 84 88" stroke="#d92d3e" strokeWidth="13" strokeLinecap="round" />
    <path d="M80 66 C 86 72, 92 76, 98 78" stroke="#d92d3e" strokeWidth="6" strokeLinecap="round" />
    <circle cx="99" cy="78" r="4" fill="#f6cba2" />
    <path d="M84 88 C 92 91, 100 92, 108 92" stroke="#20212b" strokeWidth="9" strokeLinecap="round" />
    <path d="M108 92 C 109 98, 109 102, 108 106" stroke="#20212b" strokeWidth="8" strokeLinecap="round" />
    <ellipse cx="109" cy="110" rx="6" ry="3.2" fill="#20212b" />
    <circle cx="136" cy="38" r="9" fill="#eab587" />
    <path d="M136 47 v4" stroke="#eab587" strokeWidth="5" strokeLinecap="round" />
    <path d="M136 52 L133 84" stroke="#16846b" strokeWidth="13" strokeLinecap="round" />
    <path d="M130 56 C 118 58, 104 60, 92 62" stroke="#16846b" strokeWidth="6" strokeLinecap="round" />
    <circle cx="90" cy="62" r="4" fill="#eab587" />
    <path d="M139 58 C 145 64, 149 70, 152 76" stroke="#16846b" strokeWidth="6" strokeLinecap="round" />
    <circle cx="152" cy="77" r="4" fill="#eab587" />
    <path d="M127 84 h13 l-1 8 h-11 Z" fill="#20212b" />
    <path d="M130 92 C 128 98, 127 104, 126 110" stroke="#20212b" strokeWidth="7.5" strokeLinecap="round" />
    <path d="M138 92 C 140 98, 141 104, 142 110" stroke="#20212b" strokeWidth="7.5" strokeLinecap="round" />
    <ellipse cx="125" cy="113" rx="6" ry="3.2" fill="#20212b" />
    <ellipse cx="143" cy="113" rx="6" ry="3.2" fill="#20212b" />
  </svg>
);

export const FinalShield = () => (
  <svg viewBox="0 0 220 130" fill="none" role="img" aria-label="Ilustrasi perisai tanda evaluasi selesai">
    <circle cx="110" cy="65" r="56" fill="#e8f6f1" />
    <path d="M110 30 C 124 38, 136 41, 147 41 C 147 73, 135 94, 110 104 C 85 94, 73 73, 73 41 C 84 41, 96 38, 110 30 Z" fill="#16846b" />
    <path d="M94 66 l13 13 l23 -26" stroke="#fff" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="66" cy="30" r="3.5" fill="#f3b7b1" />
    <circle cx="162" cy="26" r="4.5" fill="#f3b7b1" />
    <circle cx="168" cy="92" r="3.5" fill="#f9d5d1" />
    <circle cx="56" cy="88" r="4" fill="#f9d5d1" />
    <path d="M52 52 l5 5 M166 58 l6 -6" stroke="#e58b85" strokeWidth="3.5" strokeLinecap="round" />
  </svg>
);

export const LifeRing = () => (
  <svg viewBox="0 0 220 130" fill="none" role="img" aria-label="Ilustrasi tangan korban meraih pelampung keselamatan">
    <circle cx="110" cy="65" r="56" fill="#fff0ed" />
    <path d="M28 100 C 42 90, 54 82, 66 74" stroke="#eab587" strokeWidth="9" strokeLinecap="round" />
    <path d="M22 96 l-5 -7 M32 92 l0 -9 M42 94 l5 -6" stroke="#f3b7b1" strokeWidth="3.5" strokeLinecap="round" />
    <g className="jelly-float">
      <circle cx="142" cy="52" r="25" stroke="#fff" strokeWidth="14" />
      <circle cx="142" cy="52" r="25" stroke="#d92d3e" strokeWidth="14" strokeDasharray="19.6 19.6" />
      <circle cx="142" cy="52" r="15" stroke="#f3b7b1" strokeWidth="3" />
      <path d="M142 21 v7 M142 76 v7 M111 52 h7 M166 52 h7" stroke="#e8b4ac" strokeWidth="4" strokeLinecap="round" />
    </g>
    <DorsalHand x={64} y={72} rotate={-38} scale={0.62} />
    <path d="M24 106 C 38 98, 52 98, 66 106 C 80 114, 94 114, 108 106 C 122 98, 136 98, 150 106 C 164 114, 178 114, 196 108" stroke="#f3b7b1" strokeWidth="6" strokeLinecap="round" />
    <path d="M42 118 C 52 112, 62 112, 72 118 C 82 124, 92 124, 102 118 C 112 112, 122 112, 132 118 C 142 124, 154 124, 168 120" stroke="#f9d5d1" strokeWidth="6" strokeLinecap="round" />
  </svg>
);

export const PainCheck = () => (
  <svg viewBox="0 0 220 130" fill="none" role="img" aria-label="Ilustrasi korban memegang lengan yang masih nyeri">
    <circle cx="110" cy="65" r="56" fill="#fff0ed" />
    <circle cx="152" cy="26" r="13" fill="#fff" stroke="#f1deda" strokeWidth="3" />
    <path d="M144 36 l-7 7 l11 -2 Z" fill="#fff" stroke="#f1deda" strokeWidth="3" strokeLinejoin="round" />
    <text x="152" y="31" textAnchor="middle" fontFamily="Manrope, sans-serif" fontWeight="800" fontSize="15" fill="#d92d3e">?</text>
    <circle cx="100" cy="32" r="9.5" fill="#f6cba2" />
    <path d="M100 41 v5" stroke="#f6cba2" strokeWidth="5" strokeLinecap="round" />
    <path d="M100 46 L98 76" stroke="#d92d3e" strokeWidth="14" strokeLinecap="round" />
    <path d="M106 52 C 114 56, 121 59, 127 61" stroke="#d92d3e" strokeWidth="6.5" strokeLinecap="round" />
    <path d="M127 61 C 133 60, 139 60, 145 61" stroke="#eab587" strokeWidth="7" strokeLinecap="round" />
    <circle cx="148" cy="61" r="4" fill="#f6cba2" />
    <path d="M132 55 l2 6 M138 55 l2 6" stroke="#c22338" strokeWidth="2.6" strokeLinecap="round" />
    <path d="M93 52 C 91 60, 95 66, 103 68" stroke="#d92d3e" strokeWidth="6.5" strokeLinecap="round" />
    <circle cx="106" cy="68" r="4" fill="#f6cba2" />
    <path d="M138 48 l5 -6 M146 50 l7 -4" stroke="#e58b85" strokeWidth="3.5" strokeLinecap="round" />
    <path d="M94 74 h13 l-1 9 h-11 Z" fill="#20212b" />
    <path d="M97 82 C 95 91, 94 99, 93 107" stroke="#eab587" strokeWidth="7.5" strokeLinecap="round" />
    <path d="M104 82 C 106 91, 107 99, 108 107" stroke="#eab587" strokeWidth="7.5" strokeLinecap="round" />
    <ellipse cx="92" cy="110" rx="6.5" ry="3.4" fill="#eab587" />
    <ellipse cx="109" cy="110" rx="6.5" ry="3.4" fill="#eab587" />
  </svg>
);

export const IdCard = () => (
  <svg viewBox="0 0 160 110" fill="none" role="img" aria-label="Ilustrasi kartu identitas korban">
    <circle cx="80" cy="55" r="46" fill="#fff0ed" />
    <rect x="38" y="30" width="84" height="54" rx="9" fill="#fff" stroke="#f1deda" strokeWidth="3" />
    <path d="M38 39 a9 9 0 0 1 9 -9 h66 a9 9 0 0 1 9 9 v3 H38 Z" fill="#d92d3e" />
    <circle cx="58" cy="53" r="8" fill="#f6cba2" />
    <path d="M58 61 v3" stroke="#f6cba2" strokeWidth="4" strokeLinecap="round" />
    <path d="M47 76 C 49 66, 67 66, 69 76 Z" fill="#d92d3e" />
    <path d="M76 48 h34 M76 58 h26 M76 68 h30" stroke="#e8d8d4" strokeWidth="5" strokeLinecap="round" />
  </svg>
);

export const EmergencyArt = () => (
  <svg viewBox="0 0 160 110" fill="none" role="img" aria-label="Ilustrasi menelepon bantuan darurat">
    <circle cx="80" cy="56" r="44" fill="#fff" />
    <rect x="62" y="24" width="38" height="64" rx="9" fill="#fff" stroke="#c22338" strokeWidth="4" />
    <rect x="70" y="34" width="22" height="30" rx="4" fill="#fff0ed" />
    <text x="81" y="54" textAnchor="middle" fontSize="13" fontWeight="800" fill="#c22338" fontFamily="Manrope, sans-serif">112</text>
    <circle cx="81" cy="79" r="3.5" fill="#c22338" />
    <path d="M104 32 C 110 36, 114 42, 116 48 M110 22 C 120 28, 128 36, 131 46" stroke="#e58b85" strokeWidth="4" strokeLinecap="round" />
  </svg>
);
